import { Text, View } from "@react-pdf/renderer";
import { formatDateTimeUtc } from "../../../utils/date_formatter";
import { styles } from "../ReactPdfStyles";
import { renderApprovedOn } from "./utils";

type ReportingApprovalRecordSectionTypes = {
	data: Record<string, any>;
};

function ReportingApprovalRecordSection({
	data,
}: ReportingApprovalRecordSectionTypes) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Approval record</Text>
			<View style={styles.column}>
				<View style={styles.row}>
					<Text style={styles.labelCell}>Created by</Text>
					<Text style={styles.valueCell}>{data.author_name ?? "—"}</Text>

					<Text style={styles.labelCell}>Approved by</Text>
					<Text style={[styles.valueCell, styles.borderRight]}>
						{data.reviewer_name ?? "—"}
					</Text>
				</View>
				<View style={styles.row}>
					<Text style={styles.labelCell}>Created on</Text>
					<Text style={styles.valueCell}>
						{formatDateTimeUtc(data.submitted_on ?? "")}
					</Text>
					<Text style={styles.labelCell}>Approved on</Text>
					<Text style={[styles.valueCell, styles.borderRight]}>
						{renderApprovedOn(data)}
					</Text>
				</View>
			</View>
		</View>
	);
}

export default ReportingApprovalRecordSection;
